// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';
import { styled } from '@compiled/react';

import { SpotlightTarget } from '@atlaskit/onboarding';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withTransparentErrorBoundary';
import { LoadableAfterPaint } from '@confluence/loadable';

export { useConfluenceStandardToPremiumExperiment } from './useConfluenceStandardToPremiumExperiment';
export { useConfluenceStandardToPremiumPUBTouchpoint } from './useConfluenceStandardToPremiumPUBTouchpoint';
export { StandardToPremiumModalMountComponent } from './StandardToPremiumModalMountComponent';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	display: 'none',
	'@media (min-width: 680px)': {
		display: 'initial',
	},
});

const EditionAwarenessUpsellLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditionAwarenessUpsell" */ './EditionAwarenessUpsell'
			)
		).EditionAwarenessUpsell,
});

export const EditionAwarenessUpsellExperiment = withTransparentErrorBoundary({
	attribution: Attribution.GROWTH_LUNA,
})(({ navVersion }: { navVersion: 'nav3' | 'nav4' }) => {
	return (
		<SpotlightTarget name="edition-awareness">
			<Container>
				<EditionAwarenessUpsellLoadable navVersion={navVersion} />
			</Container>
		</SpotlightTarget>
	);
});
